const en = {
  common: {
    language: 'Language',
    english: 'English',
    danish: 'Dansk',
    close: 'Close',
    more: 'More',
    profile: 'Profile',
    myPlan: 'My Plan',
    signOut: 'Sign out',
    notifications: 'Notifications',
    notAvailable: 'N/A',
  },
  coach: {
    nav: {
      aria: 'Coach workspace',
      mobileAria: 'Coach mobile navigation',
      moreAria: 'More coach navigation',
      closeAria: 'Close coach navigation menu',
      hub: 'Coach Hub',
      hubShort: 'Hub',
      live: 'Live Session',
      liveShort: 'Live',
      capture: 'Group Test',
      captureShort: 'Test',
      manual: 'Manual Counter',
      manualShort: 'Count',
      verification: 'Review Results',
      athletes: 'Athletes',
      teamProgress: 'Team Progress',
      programs: 'Programs',
      identityStudio: 'Coach Profile',
      myProfile: 'My Profile',
      coachOs: 'Coach Hub',
      moreWorkspace: 'More',
      kicker: 'ARGUS // COACH',
      motto: 'Better players. Better people.',
    },
    header: {
      kicker: 'Coach Hub // ARGUS',
      fallbackTitle: 'Coach workspace',
      fallbackTeam: 'Athlete development',
      preview: 'Preview mode',
      profileAria: 'Open coach profile',
    },
    sections: {
      kicker: 'ARGUS // COACH',
      backAria: 'Back to coach hub',
      capture: {
        title: 'Group Test',
        description:
          'Choose the athletes you are working with and start a separate test for each player.',
      },
      review: {
        title: 'Review Results',
        description: 'Review completed tests that are ready for your confirmation.',
      },
      athletes: {
        title: 'Athletes',
        description: 'See the players connected to your coaching workspace.',
      },
      live: {
        title: 'Live Group Session',
        description: 'Follow each athlete while a group test or training session is running.',
      },
      progress: {
        title: 'Team Progress',
        description: 'See team participation, completion, and development trends.',
      },
      programs: {
        title: 'Training Programs',
        description: 'See programs and assignments for your athletes.',
      },
    },
    home: {
      kicker: 'ARGUS // COACH HUB',
      heroLead: 'COACH THE NEXT REP.',
      heroAccent: 'SEE THE WHOLE ATHLETE.',
      heroCopy:
        'Run the floor from one place. See who needs attention, start a group session, assign work and review results without losing the athlete behind the numbers.',
      today: 'Today',
      todayNote: 'Your coaching priorities',
      athletes: 'Athletes',
      athletesNote: 'Roster and player context',
      liveCapture: 'Live Session',
      liveCaptureNote: 'Follow a group test or training session',
      manualCounter: 'Manual Counter',
      manualCounterNote: 'Count reps, makes and misses for selected athletes',
      assignWork: 'Assign Work',
      assignWorkNote: 'Programs and assignments',
      verification: 'Review Results',
      verificationNote: 'Confirm completed tests',
      activeAthletes: 'Active athletes',
      totalAthletes: 'Total athletes',
      programs: 'Programs',
      completion: 'Team completion',
      currentPriority: 'Current priority',
      priorityReady: 'Your coaching workspace is ready.',
      priorityEmpty:
        'Build your roster, assign training and start recording sessions. ARGUS will surface clearer priorities as activity builds.',
      priorityActive:
        'Connected athletes: {{count}}. Keep development moving with the next useful action.',
      priorityActiveOne:
        '1 athlete connected. Keep development moving with the next useful action.',
      priorityActiveMany:
        '{{count}} athletes connected. Keep development moving with the next useful action.',
      openAthletes: 'Open Athletes',
      startCapture: 'Start Group Test',
      openLive: 'Open Live Session',
      openPrograms: 'Open Programs',
      reviewEvidence: 'Review Results',
      signalKicker: 'Team activity',
      signalTitle: 'KNOW WHO NEEDS YOU NEXT.',
      signalCopy:
        'Team activity helps you see participation and completion. Open the athlete when you need the individual story behind the number.',
      noCompletion: 'Not enough completed work yet',
      completionReady: '{{value}}% team completion',
      evidenceBoundary:
        'Completion and verification tell you what has been recorded and reviewed. They do not automatically grade the athlete’s performance.',
    },
  },
}

export default en
